import {defineStore} from 'pinia'

const name = 'appInbox'

/**
 * Boîte de réception des notifications (cloche) : liste et nombre de non lues
 */
export const useAppInboxStore = defineStore(name, {

  id: name,

  state: () => ({
    records: [],
    unread: 0,
    loaded: false,
    // Notification affichée en entier (clic sur une notification système ou dans la cloche)
    opened: null,
  }),

  actions: {
    load(payload) {
      this.records = payload?.notifications || []
      this.unread = payload?.unread || 0
      this.loaded = true
    },
    // Nouvelle notification reçue en temps réel : en tête de liste
    prepend(notification) {
      if (!notification || this.records.some(n => n.id === notification.id)) return
      this.records.unshift(notification)
      if (!notification.read) this.unread += 1
    },
    markRead(id) {
      const notification = this.records.find(n => n.id === id)
      if (notification && !notification.read) {
        notification.read = true
        this.unread = Math.max(0, this.unread - 1)
      }
    },
    markAllRead() {
      this.records.forEach(n => { n.read = true })
      this.unread = 0
    },
    remove(id) {
      const index = this.records.findIndex(n => n.id === id)
      if (index === -1) return
      if (!this.records[index].read) this.unread = Math.max(0, this.unread - 1)
      this.records.splice(index, 1)
    },
    open(notification) {
      this.opened = notification || null
    },
    close() {
      this.opened = null
    },
    clear() {
      this.records = []
      this.unread = 0
      this.loaded = false
      this.opened = null
    },
  },

  getters: {
    hasUnread: (state) => state.unread > 0,
  },
})
